import {Manufacturer} from "@app/manufacturer/shared/manufacturer";

export class Device {
  uuid: string | null;
  name: string;
  description: string;
  piecePrice: number;
  vatId: number;
  active: boolean;
  maintenanceInterval: number;
  manufacturer: Manufacturer;
}
